export default __webpack_public_path__ + "static/media/8.e87aafe8.jpg";